
import messages from '../translations';

let idiomas = new Object();

for (let lang in messages) {
	idiomas[lang] = messages[lang].enlaces;
}

export function langdetector() {
	const validLangs = Object.keys(idiomas);
	const langFromQuery = new URLSearchParams(window.location.search).get('lang');

	if (langFromQuery && validLangs.includes(langFromQuery)) {
		return langFromQuery;
	}

	let langSelected = "es";
	let path = location.pathname;

	if (path == "/" || path == "/404") {
		let localStorage = window.localStorage.getItem('language');
		if (!!!localStorage) {
			langSelected = navigator.language.substring(0, 2);
		} else {
			(!validLangs.some(i => i == localStorage)) ? langSelected = "es" : langSelected = localStorage;
		}
	} else {
		path = '/' + path.split("/")[1];

		for (let lang in idiomas) {
			let array = Object.entries(idiomas[lang]);
			(array.some(e => e[1] == path)) ? langSelected = lang : '';
		}
	}

	if (!validLangs.includes(langSelected)) {
		return "es";
	}

	return langSelected;
}


// WEBPACK FOOTER //
// ./src/langdetector/index.js